import {useEffect} from "react";
import {RouterProvider} from "react-router-dom";
import router from "router";
import {useTranslation} from "react-i18next";
import {i18nFromRoute, Language, checkLanguage} from "language";

function App() {
  const {i18n} = useTranslation();

  useEffect(() => {
    // 1) URL segment
    const seg = (window.location.pathname.split('/')[1] || '').toLowerCase();
    const routeLang = (seg === 'en' || seg === 'ua') ? (seg as Language) : checkLanguage(localStorage.getItem('lng') || '');
    const target = i18nFromRoute(routeLang); // "en" | "uk"

    if (i18n.language !== target) {
      i18n.changeLanguage(target).catch(err => console.log("Error changeLanguage", err));
    }
    localStorage.setItem('lng', target);
  }, [i18n]);

  return <RouterProvider router={router}/>;
}
export default App;
